import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/penny-whale-icon.png")